export var TerminalsStatus;
(function (TerminalsStatus) {
    TerminalsStatus[TerminalsStatus["Initial"] = 0] = "Initial";
    TerminalsStatus[TerminalsStatus["GettingTerminal"] = 1] = "GettingTerminal";
    TerminalsStatus[TerminalsStatus["GetTerminalSuccess"] = 2] = "GetTerminalSuccess";
    TerminalsStatus[TerminalsStatus["SavingTerminal"] = 3] = "SavingTerminal";
    TerminalsStatus[TerminalsStatus["SaveTerminalSuccess"] = 4] = "SaveTerminalSuccess";
    TerminalsStatus[TerminalsStatus["CancelingTerminalOrder"] = 5] = "CancelingTerminalOrder";
    TerminalsStatus[TerminalsStatus["CancelTerminalOrderSuccess"] = 6] = "CancelTerminalOrderSuccess";
    TerminalsStatus[TerminalsStatus["DeletingTerminalOrder"] = 7] = "DeletingTerminalOrder";
    TerminalsStatus[TerminalsStatus["DeleteTerminalOrderSuccess"] = 8] = "DeleteTerminalOrderSuccess";
    TerminalsStatus[TerminalsStatus["SavingTerminalOrder"] = 9] = "SavingTerminalOrder";
    TerminalsStatus[TerminalsStatus["SaveTerminalOrderSuccess"] = 10] = "SaveTerminalOrderSuccess";
    TerminalsStatus[TerminalsStatus["CompletingTerminalOrder"] = 11] = "CompletingTerminalOrder";
    TerminalsStatus[TerminalsStatus["CompleteTerminalOrderSuccess"] = 12] = "CompleteTerminalOrderSuccess";
    TerminalsStatus[TerminalsStatus["FetchingTerminals"] = 13] = "FetchingTerminals";
    TerminalsStatus[TerminalsStatus["FetchTerminalsSuccess"] = 14] = "FetchTerminalsSuccess";
    TerminalsStatus[TerminalsStatus["FetchingTerminalsOrders"] = 15] = "FetchingTerminalsOrders";
    TerminalsStatus[TerminalsStatus["FetchTerminalsOrdersSuccess"] = 16] = "FetchTerminalsOrdersSuccess";
    TerminalsStatus[TerminalsStatus["CheckingStatus"] = 17] = "CheckingStatus";
    TerminalsStatus[TerminalsStatus["CheckStatusSuccess"] = 18] = "CheckStatusSuccess";
    TerminalsStatus[TerminalsStatus["ChangingStatusOrders"] = 19] = "ChangingStatusOrders";
    TerminalsStatus[TerminalsStatus["ChangeStatusOrdersSuccess"] = 20] = "ChangeStatusOrdersSuccess";
    TerminalsStatus[TerminalsStatus["Error"] = 21] = "Error";
})(TerminalsStatus || (TerminalsStatus = {}));
